import {Box, Container, styled} from "@mui/material";
import {ConferenceType} from "data/enums";
import {css} from "@mui/material/styles";
import afcBgLogo from "assets/img/icons/opacity-afc-logo.png";
import nfcBgLogo from "assets/img/icons/opacity-nfc-logo.png";
import {media} from "assets/css/media";

export const HPWrapper = styled(Box)`
	width: 100%;
	display: flex;
	flex: 1 1 100%;
	flex-direction: column;
`;

export const TwoColumnContainer = styled(Container)`
	display: grid;
	grid-template-columns: minmax(45%, 1fr) minmax(55%, 1fr);
	gap: 20px;
	padding: 20px 0;
`;

export const TwoColumnResultedContainer = styled(Box)`
	display: grid;
	grid-template-columns: minmax(45%, 1fr) minmax(45%, 1fr);
	gap: 20px;
	padding: 20px 0;

	@media (max-width: ${media.desktop}) {
		grid-template-columns: 1fr;
	}
`;
export const MobileColumnContainer = styled(Container)`
	display: flex;
	flex-direction: column;
	padding-top: 20px;
	padding-bottom: 20px;
	position: relative;

	@media (max-width: ${media.mobile}) {
		padding: 0 2px 20px;
	}

	.tab_navigation {
		padding: 20px;
		background: #f0f0f0;
		//position: sticky;
		//top: 48px;
		//z-index: 29;

		> div {
			background: #fff;
			border-radius: 25px;
			border: 1px solid #c5c5c5;
		}

		button {
			color: #151515;
			background: #fff;
			text-align: center;
			font-family: var(--fontFamilyBase);
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: 140%; /* 19.6px */
			height: 40px;
			padding: 8px 12px;
			box-sizing: border-box;
			border-radius: 25px;
			text-transform: unset;

			@media (max-width: ${media.mobile}) {
				flex: 1;
				width: 100%;
				max-width: unset;
			}

			&.Mui-selected {
				color: #fff;
				//background: var(--thirdColor);
				background: var(--primaryColor);
			}

			&.Mui-disabled {
				background-color: #c7c7cb;
				color: rgba(16, 16, 15, 0.22);
			}
		}

		.MuiTabs-indicator {
			background-color: transparent;
		}
	}

	.tab_panel {
		padding: 0;

		// @media (max-width: ${media.mobile}) {
		// 	padding: 10px 15px 20px;
		// }
	}
`;
export const GameSchedule = styled(Box)`
	display: flex;
	flex-direction: column;
	//box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.20);
`;
export const GameStandings = styled(Box)`
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	//box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.20);
`;
export const StandingsColumn = styled(Box)`
	display: flex;
	flex: 1 1 50%;
	flex-direction: column;
`;
export const LadderBox = styled(Box)`
	display: flex;
	justify-content: center;

	@media (max-width: ${media.mobile}) {
		align-items: center;
	}
`;
const nfcStyles = css`
	background:url("${nfcBgLogo}") no-repeat 95% 50% #103365;
`;
const afcStyles = css`
	background:url("${afcBgLogo}") no-repeat 95% 50% #d50a0a;
`;
export const ConferenceHeader = styled(Box)<{type: ConferenceType}>`
	height: 44px;
	padding: 10px 14px;
	color: #fff;
	font-family: var(--fontFamilyBase);
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 140%; /* 22.4px */
	text-transform: uppercase;
	margin: 1px 0 1px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	${({type}) => type === ConferenceType.NFC && nfcStyles}
	${({type}) => type === ConferenceType.AFC && afcStyles}
`;
export const TableRow = styled(Box)`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;

	height: 44px;
	padding: 10px 6px 10px 14px;

	color: #151515;
	/* Copy/Body 2 (Semi-Bold) */
	font-family: var(--fontFamilyBase);
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 140%; /* 19.6px */
	gap: 5px;
	border: 1px solid #c5c5c5;
	margin-top: -1px;
	position: relative;

	&.right {
		border-left: none;
	}

	&:last-child {
		border-radius: 0 0 6px 6px;
	}
`;
